import { createFileRoute, notFound } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"

import { QuoteRequestForm } from "@/components/quote-request/quote-request-form"
import { CERTIFIED_THRESHOLD } from "@/constants/company/certification"

const fetchCompanyContactData = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => data as { longSlug: string })
  .handler(async ({ data }) => {
    const { fetchByLongSlugWithMethodologyAndMarket } =
      await import("@/db/queries/company")
    const { longSlug } = data

    const companyData = await fetchByLongSlugWithMethodologyAndMarket(longSlug)

    if (!companyData || !companyData.is_page_qualified) return null

    const isCompanyCertified =
      companyData.methodology_output.trustScore >= CERTIFIED_THRESHOLD

    return {
      companyId: companyData.id,
      companyName: companyData.name,
      companyLongSlug: longSlug,
      isCompanyCertified,
      trustScore: companyData.methodology_output.trustScore,
    }
  })

export const Route = createFileRoute("/company/$longSlug/contact")({
  loader: async ({ params }) => {
    const result = await fetchCompanyContactData({
      data: { longSlug: params.longSlug },
    })
    if (!result) throw notFound()
    return result
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return {
      meta: [
        { title: `Get a Quote from ${loaderData.companyName}` },
        { name: "robots", content: "noindex, nofollow" },
      ],
    }
  },
  component: CompanyContactPage,
})

function CompanyContactPage() {
  const {
    companyId,
    companyName,
    companyLongSlug,
    isCompanyCertified,
    trustScore,
  } = Route.useLoaderData()

  return (
    <div className="bg-muted flex min-h-screen flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="bg-background flex max-h-[900px] min-h-[700px] w-full max-w-[480px] flex-col overflow-hidden border-2 shadow-2xl">
        <QuoteRequestForm
          companyId={companyId}
          companyName={companyName}
          companyLongSlug={companyLongSlug}
          isCompanyCertified={isCompanyCertified}
          trustScore={trustScore}
        />
      </div>
    </div>
  )
}
